import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../Forms/Element/CustomSelect';
import axiosInstance from '../../../../../services/AxiosInstance';
import Api from '../../../../../constants/Api';
import { SearchOperation } from '../../../../../utils/ApiUtils';

/**
 * Componente responsável por listar os produtos.
 */
const ProductSelect = (props) => {

  const { t } = useTranslation();
  const [entities, setEntities] = useState([]);
  const { type } = props;

  useEffect(() => {
    /**
     * Realiza a busca das filiais da empresa na API.
     * A empresa é identificada a partir do token.
     */
    function findAll() {
      setEntities([]);

      let payload = {
        filters: []
      };

      if (type) {
        payload.filters.push({
          field: "type",
          operation: SearchOperation.EQUAL,
          value: type
        });
      }

      axiosInstance.post(`${Api.main.product}/findByFilters`, payload)
        .then(response => {
          let entities = [];

          for (var i = 0; i < response.data.length; i++) {
            entities.push(
              {
                value: response.data[i].id,
                label: response.data[i].name,
                // A duração acompanha a opção para o agendamento preencher o tempo do
                // serviço sem precisar buscar o cadastro de novo.
                duration: response.data[i].duration,
                // Preço de venda e de custo acompanham a opção para o consumo do colaborador
                // mostrar o valor de cada escolha sem buscar o cadastro de novo.
                price: response.data[i].price,
                costPrice: response.data[i].costPrice,
                // Reserva exigida pelo serviço, para o agendamento oferecer o recebimento já
                // ao marcar o horário.
                requiresDeposit: response.data[i].requiresDeposit,
                depositType: response.data[i].depositType,
                depositValue: response.data[i].depositValue
              }
            );

            setEntities(entities);
          }
        });
    }

    findAll();
  }, [type]);

  return (
    <CustomSelect options={entities} value={props.value} onChange={props.onChange} isClearable placeholder={t("select")} isDisabled={props.isDisabled} />
  )
}

export default ProductSelect;
